import clsx from 'clsx'
import {chain} from 'lodash'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Hidden from '@mui/material/Hidden'
import TransferList from './TransferList'
import CheckList from './CheckList'

const useStyles = makeStyles(selectStudentsStyles)

export default function SelectStudents (props) {

  const {translate} = props.context
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Hidden smDown>
        <TransferList
          label={({name}) => name}
          left={props.students} 
          LeftHeader={props => (
            <Box className={clsx(classes.label, "studentsHeader")}>
              {translate('students')}:
            </Box>
          )}
          RightHeader={props => (
            <Box className={clsx(classes.label, "selectedHeader")}>
              {translate('selected')}:
            </Box>
          )}
          disabled={props.expired}
          right={props.selectedStudents} 
          checklist={props.checkedStudents}
          onChecked={props.onStudentsChecked}
          onTransfer={props.onStudentsChange}
        />
      </Hidden>
      <Hidden smUp>
        <CheckList
          items={
            chain(props.students)
            .concat(props.selectedStudents)
            .map(s => ({...s, label: s.name}))
            .orderBy(['label', 'id'])
            .value()
          }
          selectAllTitle={translate('students_label')}
          onChecked={props.onStudentsChange}
          checklist={props.selectedStudents.map(s => s.id)}
        />
      </Hidden>
  </Box>
  );
}

function selectStudentsStyles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      padding: 0,
      overflowY: 'auto'
    },
    label: {
      marginBottom: 5
    }
  }
}
